<template>
  <div class="itinerary-selection spa-soft-page">
    <ItineraryHeader />
    <TimeslotList />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { SPA_SOFT_ROUTE_NAMES } from '@components/07.spa-soft/spa-soft/routes/spa-soft-routes'
  import ItineraryHeader from './components/itinerary-header.vue'
  import TimeslotList from './components/timeslot/timeslot-list.vue'

  export default {
    name: 'ItinerarySelection',
    components: {
      ItineraryHeader,
      TimeslotList
    },
    beforeRouteEnter(to, from, next) {
      next(async (vm) => {
        if (vm.ready) {
          if (vm.hasGuestsWithNoSelectedTreatments || vm.availableItinerary.length === 0) {
            vm.goToStep(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE)
            return false
          }
          await vm.updateFooterLabel()
        }
        return true
      })
    },
    computed: {
      ...mapState('spaSoft', ['ready', 'availableItinerary']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('spaSoft', ['hasGuestsWithNoSelectedTreatments']),
    },
    watch: {
      async ready(val) {
        if (val) {
          if (this.availableItinerary.length === 0) {
            this.goToStep(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE)
          }
          await this.updateFooterLabel()
        }
      },
    },
    created() {
      this.$track({ event: 'pageView' })
    },
    methods: {
      ...mapActions('spaSoft', ['updateNextStepButton', 'goToStep']),
      async updateFooterLabel() {
        const label = this.tc('spaSoft.step1.itinerarySelection.selectItineraryCta')
        await this.updateNextStepButton({
          label,
          step: 2,
          customClass: 'continue',
        })
      },
    }
  }
</script>
